<div class="dashboard">

  <!-- Page header -->
  <header class="dashboard-header animate-fade-in">
    <div class="dashboard-header__text">
      <h2 class="dashboard-title">Mis tipos de evento</h2>
      <p class="dashboard-subtitle">
        Creá y compartí tu link de reserva con clientes. Tenés
        <strong>12 turnos libres esta semana.</strong>
      </p>
    </div>
    <div class="dashboard-header__actions">
      <button class="btn-secondary" routerLink="/availability">
        <span class="material-symbols-outlined">settings</span>
        Disponibilidad
      </button>
      <button class="btn-primary" routerLink="/booking">
        <span class="material-symbols-outlined">add</span>
        Crear nuevo
      </button>
    </div>
  </header>

  <!-- Stats strip (social proof + availability heuristic) -->
  <div class="stats-strip animate-fade-in delay-1">
    <div class="stat-pill">
      <span class="material-symbols-outlined" style="color: var(--primary);">calendar_check</span>
      <div>
        <span class="stat-value">38</span>
        <span class="stat-label">reservas este mes</span>
      </div>
    </div>
    <div class="stat-pill">
      <span class="material-symbols-outlined" style="color: var(--error);">trending_up</span>
      <div>
        <span class="stat-value">+22%</span>
        <span class="stat-label">vs mes anterior</span>
      </div>
    </div>
    <div class="stat-pill">
      <span class="material-symbols-outlined" style="color: var(--tertiary);">star</span>
      <div>
        <span class="stat-value">4.9</span>
        <span class="stat-label">valoración promedio</span>
      </div>
    </div>
  </div>

  <!-- Event type cards grid -->
  <section class="cards-grid">

    <!-- Card FREE: 30 min -->
    <div class="event-card animate-fade-in delay-1">
      <div class="event-card__header">
        <div class="event-card__icon event-card__icon--primary">
          <span class="material-symbols-outlined">timer</span>
        </div>
        <div class="free-badge">Free</div>
      </div>
      <h3 class="event-card__title">Consulta inicial 30 min</h3>
      <p class="event-card__desc">Llamada de descubrimiento para nuevos proyectos.</p>
      <div class="event-card__footer">
        <span class="event-card__meta">
          <span class="material-symbols-outlined" style="font-size:.9rem">public</span>
          Link público
        </span>
        <button class="event-card__cta" (click)="copyPublicLink()">
          <span class="material-symbols-outlined" style="font-size:.9rem">link</span>
          Copiar link
        </button>
      </div>
    </div>

    <!-- Card FREE: 60 min -->
    <div class="event-card animate-fade-in delay-2">
      <div class="event-card__header">
        <div class="event-card__icon event-card__icon--primary">
          <span class="material-symbols-outlined">architecture</span>
        </div>
        <div class="free-badge">Free</div>
      </div>
      <h3 class="event-card__title">Revisión de planos 60 min</h3>
      <p class="event-card__desc">Análisis profundo de planos y restricciones del terreno.</p>
      <div class="event-card__footer">
        <span class="event-card__meta">
          <span class="material-symbols-outlined" style="font-size:.9rem">public</span>
          Link público
        </span>
        <button class="event-card__cta" (click)="copyPublicLink()">
          <span class="material-symbols-outlined" style="font-size:.9rem">link</span>
          Copiar link
        </button>
      </div>
    </div>

    <!-- Card PRO: Group (locked — endowment effect: muestra lo que pierden) -->
    <div class="event-card event-card--locked animate-fade-in delay-3">
      <div class="event-card__pro-badge">
        <span class="material-symbols-outlined" style="font-size:.8rem; font-variation-settings:'FILL' 1;">crown</span>
        Solo PRO
      </div>
      <div class="event-card__header">
        <div class="event-card__icon event-card__icon--muted">
          <span class="material-symbols-outlined">groups</span>
        </div>
      </div>
      <h3 class="event-card__title">Taller grupal de diseño</h3>
      <p class="event-card__desc">Sesión colaborativa con múltiples participantes.</p>
      <div class="event-card__footer">
        <span class="event-card__meta event-card__meta--locked">
          <span class="material-symbols-outlined" style="font-size:.9rem">lock</span>
          Función bloqueada
        </span>
        <button class="event-card__cta event-card__cta--pro" routerLink="/settings">
          Activar
        </button>
      </div>
    </div>

    <!-- Card PRO: Payment -->
    <div class="event-card event-card--locked animate-fade-in delay-4">
      <div class="event-card__pro-badge">
        <span class="material-symbols-outlined" style="font-size:.8rem; font-variation-settings:'FILL' 1;">crown</span>
        Solo PRO
      </div>
      <div class="event-card__header">
        <div class="event-card__icon event-card__icon--muted">
          <span class="material-symbols-outlined">payments</span>
        </div>
      </div>
      <h3 class="event-card__title">Consulta paga</h3>
      <p class="event-card__desc">Cobro seguro antes de confirmar la reunión. Sin seguimiento manual.</p>
      <div class="event-card__footer">
        <span class="event-card__meta event-card__meta--locked">
          <span class="material-symbols-outlined" style="font-size:.9rem">lock</span>
          Función bloqueada
        </span>
        <button class="event-card__cta event-card__cta--pro" routerLink="/settings">
          Activar
        </button>
      </div>
    </div>

    <!-- Empty state CTA -->
    <div class="event-card event-card--add animate-fade-in delay-5" routerLink="/booking">
      <div class="add-icon">
        <span class="material-symbols-outlined">add</span>
      </div>
      <p class="event-card__title">Crear tipo nuevo</p>
      <p class="event-card__desc">Hasta 3 en el plan Free</p>
    </div>

  </section>

  <!-- Info bento (peak-end rule: dejar un recuerdo positivo al final de la pantalla) -->
  <section class="bento-info animate-fade-in delay-5">

    <!-- Upcoming slot -->
    <div class="bento-card bento-card--accent">
      <div class="bento-card__content">
        <h4>Fluid Scheduling</h4>
        <p>Tu calendario tiene <strong>12 slots libres</strong> esta semana. Agrupá llamadas para optimizar tu flujo.</p>
      </div>
      <span class="material-symbols-outlined bento-card__bg-icon">auto_awesome</span>
    </div>

    <!-- Last booking (social proof) -->
    <div class="bento-card">
      <p class="text-muted" style="margin-bottom: var(--space-3);">Última reserva</p>
      <p class="bento-card__title">Revisión de planos · Loft moderno</p>
      <div class="bento-card__pills">
        <span class="pill">Mañana a las 10:00</span>
        <span class="pill pill--primary">Confirmado</span>
      </div>
    </div>

  </section>

</div>
